import { render, staticRenderFns } from "./AddAdditionalDependents.vue?vue&type=template&id=4d52f5d6&"
import script from "./AddAdditionalDependents.vue?vue&type=script&lang=js&"
export * from "./AddAdditionalDependents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports